import {useRef} from 'react'
import {useSelector} from 'react-redux'
import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {useCheckPriceWatchMismatch} from 'components/PriceWatch/hooks/useCheckPriceWatchMismatch'
import {getOverlayVisibility} from 'modules/overlay/selectors'
import {OverlayType} from 'modules/overlay/types'
import {getAnchorHotelId} from 'modules/sapiSearch/selectors'
import {getClickedOfferRate} from 'modules/search/selectors'

import PriceUpdateBottomSheet from './PriceUpdateBottomSheet/PriceUpdateBottomSheet'
import {PriceWatchBottomSheetLoadable} from './PriceWatchBottomSheet'
import {PriceWatchPopUpLoadable} from './PriceWatchPopUp'

export const PriceWatchOverlays = () => {
  const hasShownPriceMismatchBottomSheet = useRef(false)

  const anchorHotelId = useSelector(getAnchorHotelId)
  const {isMobile} = useDeviceLayout()
  const clickedOfferRate = useSelector(getClickedOfferRate)

  const {
    hasMismatch,
    isPriceIncrease,
    currentTopPrice,
    percentageDifference,
    priceDifference
  } = useCheckPriceWatchMismatch({
    hotelId: anchorHotelId,
    clickedOfferRate
  })

  const shouldShowPriceMismatchBottomSheet =
    hasMismatch && !hasShownPriceMismatchBottomSheet.current

  const isPriceWatchOverlayShown = useSelector(state =>
    getOverlayVisibility(state, OverlayType.PriceWatchOverlay)
  )

  if (!isPriceWatchOverlayShown && !shouldShowPriceMismatchBottomSheet) {
    return null
  }

  if (isPriceWatchOverlayShown) {
    return isMobile ? (
      <PriceWatchBottomSheetLoadable />
    ) : (
      <PriceWatchPopUpLoadable />
    )
  }

  if (shouldShowPriceMismatchBottomSheet) {
    hasShownPriceMismatchBottomSheet.current = true

    return (
      <PriceUpdateBottomSheet
        isIncrease={isPriceIncrease}
        isOpen={shouldShowPriceMismatchBottomSheet}
        alertPrice={clickedOfferRate}
        currentPrice={currentTopPrice}
        percentageDifference={percentageDifference}
        priceDifference={priceDifference}
      />
    )
  }
}
